import React, { Component } from 'react'
import PropTypes from 'prop-types'
import lottieSourcesMap from '../../../assets/lottieSources/lottieSourcesMap'
import LottieWrapper from './LottieWrapper'
import UberFacts from '../uberFacts/UberFacts'

export default class LottieLoader extends Component {
  static propTypes = {
    height: PropTypes.number,
    isPaused: PropTypes.bool,
    isStopped: PropTypes.bool,
    options: PropTypes.any,
    width: PropTypes.number,
    animationName: PropTypes.string,
    isReady: PropTypes.bool.isRequired,
    loadingTime: PropTypes.number,
    noMessage: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string]),
    noData: PropTypes.bool,
    uberFacts: PropTypes.array,
    isMobile: PropTypes.bool,
    loadingLottieDivMarginTop: PropTypes.number,
  }

  static defaultProps = {
    height: 300,
    isPaused: false,
    isStopped: false,
    width: 300,
    options: {
      loop: true,
      autoplay: true,
      animationData: lottieSourcesMap.GEARS,
    },
    animationName: lottieSourcesMap.GEARS,
    noMessage: false,
    error: null,
    noData: false,
    uberFacts: null,
    isMobile: false,
    loadingLottieDivMarginTop: 30,
  }

  constructor(props) {
    super(props)

    this._isMounted = false

    this.state = {
      isFinishedLoading: false,
    }

    this.updateIsFinishedLoading = nextState => this.setState({ isFinishedLoading: nextState })
  }

  componentDidMount() {
    this._isMounted = true
    setTimeout(() => {
      if (this._isMounted) this.updateIsFinishedLoading(true)
    }, this.props.loadingTime)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isReady && !nextProps.isReady) {
      this.updateIsFinishedLoading(false)
      setTimeout(() => {
        if (this._isMounted) this.updateIsFinishedLoading(true)
      }, this.props.loadingTime)
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  render() {
    const {
      children,
      options,
      animationName,
      isReady,
      noMessage,
      error,
      noData,
      uberFacts,
      isMobile,
      loadingLottieDivMarginTop,
      ...rest
    } = this.props
    const { isFinishedLoading } = this.state

    if (noData) {
      return (
        <div className="text-center mt-5">
          <LottieWrapper
            height={200}
            options={Object.assign({}, options, { animationData: lottieSourcesMap.EMOJI_SHOCK })}
            {...rest}
          />
          <h1 className="text-muted">Sorry, No Data Found.</h1>
        </div>
      )
    }

    if (error) {
      return (
        <div className="text-center mt-5">
          <LottieWrapper
            {...rest}
            height={200}
            options={Object.assign({}, options, { animationData: lottieSourcesMap.SAD_CLOUD })}
          />
          <h1 className="text-muted">
            {error || 'Looks like something went wrong. Please refresh and try again.'}
          </h1>
        </div>
      )
    }

    if (!isReady || !isFinishedLoading) {
      return (
        <div className="text-center" style={{ marginTop: loadingLottieDivMarginTop }}>
          <LottieWrapper
            {...rest}
            options={Object.assign({}, options, {
              animationData:
                animationName === 'GRADUATE'
                  ? window.graduateLottie
                  : lottieSourcesMap[animationName],
            })}
          />
          {uberFacts && <UberFacts isMobile={isMobile} uberFacts={uberFacts} />}
          {!noMessage && <h4 className="text-muted">Finding results...</h4>}
        </div>
      )
    }

    return children
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/lotties/LottieLoader.js